import { Card, Grid, Paper, Typography, Link, CardContent, Stack, Tooltip, Button, Checkbox, CardHeader, List, ListItem, ListItemText, ListItemSecondaryAction, Switch, Collapse, ListItemButton, ListItemIcon, CardActions, Box, Divider } from '@mui/material';
import { useCreatePreferenceMutation, useListPreferencesQuery, useUpdatePreferenceMutation } from '../features/model/preferenceSlice';
import { useListCarriersQuery, useListPackagesQuery, useListServicesQuery } from '../features/shipping/shippingSlice';
import Loading from '../components/Loading';
import { ExpandLess, ExpandMore, StarBorder } from '@mui/icons-material';
import React from 'react';

const getEnabledStatus = (objectCode, prefsData) => {
  return (prefsData[objectCode] === undefined) ? true : prefsData[objectCode];
}

const packageCode = (packageObject) => {
  return `${packageObject.code}_${packageObject.carrierCode}`
}

const ServiceLineItem = ({serviceObject, prefs, onChange}) => {
  const handleChange = (event) => {
      onChange(serviceObject.code, event.target.checked)
  }
  return <>
          <ListItem key={serviceObject.code}>
            <Checkbox sx={{ marginLeft: 10 }} edge="start" checked={getEnabledStatus(serviceObject.code, prefs)} onChange={handleChange}></Checkbox>
            <ListItemText>{serviceObject.name}</ListItemText>
          </ListItem>
        </>
}

const PackageLineItem = ({packageObject, prefs, onChange}) => {
  const handleChange = (event) => {
      onChange(packageCode(packageObject), event.target.checked)
  }
  return <>
          <ListItem key={packageObject.code}>
            <Checkbox sx={{ marginLeft: 10 }} edge="start" checked={getEnabledStatus(packageCode(packageObject), prefs)} onChange={handleChange}></Checkbox>
            <ListItemText>{packageObject.name}</ListItemText>
          </ListItem>
        </>
}

const CarrierLineItem = ({carrierObject, prefs, onChange}) => {
  const [open, setOpen] = React.useState(false);
  const [checked, setChecked] = React.useState(true);
  const handleClick = () => {
    setOpen(!open);
  };


  const { data: servicesData, isLoading: servicesLoading, isSuccess: servicesSuccess, isError: servicesIsError, error: servicesError} = useListServicesQuery({carrier: carrierObject.code});
  const { data: packagesData, isLoading: packagesLoading, isSuccess: packagesSuccess, isError: packagesIsError, error: packagesError} = useListPackagesQuery({carrier: carrierObject.code});

  if (servicesLoading || packagesLoading) {
    return <Loading />
  }

  if (servicesIsError || packagesIsError) {
    console.log("Whoops, what happened here?")
    return <></>
  }

  const handleChange = (event) => {
    onChange(carrierObject.code, event.target.checked)
    for (const serviceObject of servicesData.services) {
      onChange(serviceObject.code, event.target.checked)
    }
    for (const packageObject of packagesData.packages) {
      onChange(packageCode(packageObject), event.target.checked)
    }
  }

  var any_false = false
  for (const serviceObject of servicesData.services) {
    if (!getEnabledStatus(serviceObject.code, prefs)) {
      any_false = true
    }
  }
  for (const packageObject of packagesData.packages) {
    if (!getEnabledStatus(packageCode(packageObject), prefs)) {
      any_false = true
    }
  }
  const enabled = getEnabledStatus(carrierObject.code, prefs)

  return <>
        <ListItem key={carrierObject.shippingProviderId} onClick={handleClick}>
        <Checkbox edge="start" checked={enabled} indeterminate={enabled && any_false} onChange={handleChange}></Checkbox>
          <ListItemText sx={{ paddingRight: 10 }}>{carrierObject.name}</ListItemText>

          <ListItemSecondaryAction>
            {open ? <ExpandLess /> : <ExpandMore />}
          </ListItemSecondaryAction>

        </ListItem>
        <Collapse in={open} timeout="auto" unmountOnExit>
        <Box>
          <List component="div" disablePadding>
            <Typography sx={{paddingLeft: 12}} variant="h2">Services</Typography>
            {servicesData.services.map((object, i) => <ServiceLineItem serviceObject={object} prefs={prefs} key={object.code} onChange={onChange} />)}
          </List>
          <Divider />
          <List component="div" disablePadding>
            <Typography sx={{paddingLeft: 12, marginTop: 2}} variant="h2">Packages</Typography>
            {packagesData.packages.map((object, i) => <PackageLineItem packageObject={object} prefs={prefs} key={object.code} onChange={onChange} />)}
          </List>
        </Box>
      </Collapse>
    </>

}

const ShippingPrefList = ({prefsData}) => {
  const rawPrefs = (prefsData.objects.length == 0) ? {"value": "{}", "id": ""} : prefsData.objects[0]
  const [prefs, setPrefs] = React.useState(JSON.parse(rawPrefs.value));
  const { data: carriersData, isLoading: carriersLoading, isSuccess: carriersSuccess, isError: carriersIsError, error: carrierError } = useListCarriersQuery();
  const [updatePref] = useUpdatePreferenceMutation();
  const [createPref] = useCreatePreferenceMutation();

  const handlePreferenceChange = (code, value) => {
    setPrefs(prevValues => ({
      ...prevValues,
      [code]: value
    }))
  }

  const savePrefs = () => {
    var data = {"value": JSON.stringify(prefs), "category": "shipping", "key": "enabled_services", "label": "Enabled Shipping Services", "access": "full", "last_changed_by":""}
    if (rawPrefs.id === null || rawPrefs.id === '') {
      createPref(data)
    } else {
      updatePref({preference_id: rawPrefs.id, data: {...data}})
    }
  }
  if (carriersLoading) {
    return <Loading />
  }

  if (carriersIsError) {
    return <div>Error</div>
  }

  return <Card>
          <CardHeader title="Shipping Services" titleTypographyProps={{variant: "h2"}} subheader="" />
          <CardContent>
            <List>
              {carriersData.carriers.map((object, i) => <CarrierLineItem carrierObject={object} prefs={prefs} key={object.shippingProviderId} onChange={handlePreferenceChange} />)}
            </List>
          </CardContent>
          <CardActions>
            <Button variant="contained" onClick={savePrefs}>Save</Button>
          </CardActions>
        </Card>
}

const ShippingSettingsView = () => {
  let query_filters = { category: "shipping", key: "enabled_services"}
  const { data: prefsData, isLoading: prefsLoading, isSuccess: prefsSuccess, isError: prefsIsError, error: prefsError } = useListPreferencesQuery(query_filters);

  if (prefsLoading) {
    return <Loading />
  }

  if (prefsIsError) {
    return <div>Error</div>
  }

  return <Stack sx={{marginTop: 2, marginBottom: 4}} spacing={2}><Paper>{<ShippingPrefList prefsData={prefsData} />}</Paper></Stack>
}


export { ShippingSettingsView };